import { useState } from "react";
import * as S from "./style";
import { useLocation, NavLink } from "react-router-dom";
import { useAuth } from "context/AuthContext";
/**
 * Component
 */
import LogoMundialCrop from "../../assets/logo192.png";
import Logout from "../../components/Logout";
import { useOpenModal } from "../../hooks/useOpenModal";
import { useOpenSidebar } from "../../hooks/useOpenSidebar";
/**
 * icons
 */
import {
  SignOut,
  User,
  CircleHalfTilt,
  ArrowLeft,
  ArrowRight,
} from "@phosphor-icons/react";

export default function Aside() {
  const location = useLocation();
  const iconSize = 24;
  const UserAuthenticated = useAuth();
  const { isOpenModal, toggleModalVisibility } = useOpenModal();
  const { isOpenSidebar, toggleSidebar } = useOpenSidebar();
  const [tooltip, setTooltip] = useState<string | null>(null);

  const menuItemsTop = [
    { icon: <CircleHalfTilt size={iconSize} />, title: "Lente", path: "/lente", path_secondary: '/estoque' },
  ];

  const menuItemsBottom = [
    { icon: <User size={iconSize} />, title: "Usuário", path: "/usuario" },
  ];

  return (
    <S.Container isOpen={isOpenSidebar}>

      <S.HamburgerButton onClick={toggleSidebar}>
        {isOpenSidebar ? (
          <ArrowLeft size={iconSize} />
        ) : (
          <ArrowRight size={iconSize} />
        )}
      </S.HamburgerButton>

      <S.Content>
        <S.ContentImage>
          Logo
          {/* <S.Image src={LogoMundialCrop} alt="Logo Óticas Mundial" /> */}
        </S.ContentImage>
        <S.ContentMenu>
          <S.Divider>
            {menuItemsTop.map((menu, index) => (
              <NavLink
                to={menu.path}
                style={{ color: "black", textDecoration: "none" }}
                key={index}
              >
                <S.Menu
                  onMouseEnter={() => !isOpenSidebar && setTooltip(menu.title)}
                  onMouseLeave={() => setTooltip(null)}
                  className={location.pathname === menu.path || location.pathname === menu.path_secondary ? "active" : ""}
                >
                  {menu.icon}
                  {isOpenSidebar && <S.TitleMenu>{menu.title}</S.TitleMenu>}
                  {!isOpenSidebar && tooltip === menu.title && (
                    <S.Tooltip>{menu.title}</S.Tooltip>
                  )}
                </S.Menu>
              </NavLink>
            ))}
          </S.Divider>

          <S.Divider>
            {/* Borda entre as seções */}
            {menuItemsBottom.map((menu, index) => (
              <NavLink
                to={menu.path}
                style={{ color: "black", textDecoration: "none" }}
                key={index}
              >
                <S.Menu
                  onMouseEnter={() => !isOpenSidebar && setTooltip(menu.title)}
                  onMouseLeave={() => setTooltip(null)}
                  className={location.pathname === menu.path ? "active" : ""}
                >
                  {menu.icon}
                  {isOpenSidebar && <S.TitleMenu>{menu.title}</S.TitleMenu>}
                  {!isOpenSidebar && tooltip === menu.title && (
                    <S.Tooltip>{menu.title}</S.Tooltip>
                  )}
                </S.Menu>
              </NavLink>
            ))}

            <S.Menu
              onMouseEnter={() => !isOpenSidebar && setTooltip("sair")}
              onMouseLeave={() => setTooltip(null)}
              onClick={toggleModalVisibility}
            >
              <SignOut size={iconSize} />
              {isOpenSidebar && <S.TitleMenu>Sair</S.TitleMenu>}
              {!isOpenSidebar && tooltip === "sair" && (
                <S.Tooltip>{"sair"}</S.Tooltip>
              )}
            </S.Menu>
          </S.Divider>
        </S.ContentMenu>
      </S.Content>

      <S.Footer>
        {isOpenSidebar && (
          <S.InforUser>
            <p>{UserAuthenticated.user?.first_name}</p>
            <span>{UserAuthenticated.user?.email}</span>
          </S.InforUser>
        )}
        <S.User onClick={toggleSidebar}>
          <S.LogoUser>
            {isOpenSidebar ? (
              <ArrowLeft size={iconSize} />
            ) : (
              <ArrowRight size={iconSize} />
            )}
          </S.LogoUser>
        </S.User>
      </S.Footer>

      {isOpenModal && (
        <Logout isOpen={isOpenModal} setModalOpen={toggleModalVisibility} />
      )}
    </S.Container>
  );
}
